export default __webpack_public_path__ + "static/media/bike.8e577a70.svg";